import React from 'react';
import MessageDate from '../Message/MessageDate';
import { getActivityDetails } from '../../utils/conversationActivities';

function Activity({ activity }) {
  const { createdAt } = activity;

  const {
    iconClass: strategyIconClass,
    summary,
    meta,
  } = getActivityDetails(activity);

  return (
    <li className="activity-feed-item pb-4">
      <div className="activity-feed-icon">
        <i className={`far ${strategyIconClass}`} aria-hidden="true" />
      </div>
      <div className="activity-feed-data">
        <span className="activity-feed-title">{summary}</span>
        <span className="activity-feed-meta">
          <MessageDate received_at={createdAt} /> {meta}
        </span>
      </div>
    </li>
  );
}

function Activities({ activities, conversation, channels }) {
  const firstMessageChannel = channels.find(
    (channel) => channel.id === conversation?.first_message_channel
  );

  const conversationStartedDate = conversation?.createdAt;
  const renderFeed = () => {
    const conversationStartedActivity = {
      id: 'conversation-started',
      activity_type: 'conversation-started',
      activity_summary: 'Conversation started',
      createdAt: conversationStartedDate,
      actor_id: null,
      actor: null,
      associated: null,
      associated_type: null,
      associated_id: null,
      channel: firstMessageChannel?.name || 'Unknown channel',
    };

    const activityFeed = [conversationStartedActivity, ...activities];
    return (
      <ul className="activity-feed list-unstyled mb-0">
        {activityFeed.map((activity) => {
          return <Activity key={activity.id} activity={activity} />;
        })}
        {!activityFeed.length ? (
          <div className="activity-feed-meta">
            No conversation activites found
          </div>
        ) : null}
      </ul>
    );
  };

  return (
    <div
      id="conversation-activity"
      className="accordion-collapse collapse show"
    >
      <div className="accordion-body">{renderFeed()}</div>
    </div>
  );
}

export default Activities;
